import _ from "lodash";
import * as L from "leaflet";
import { LMarker } from "vue2-leaflet";
import "leaflet-rotatedmarker";
import "leaflet-routing-machine";

export default {
	extends: LMarker,
	props: {
		extraClass: {
			custom: true,
			default: "normal"
		},
		options: {
			default: () => {
				return {};
			}
		},
		icon: {
			default: () => {
				return new L.Icon.Default();
			}
		}
	},
	methods: {
		setExtraClass(extraClass) {
			const classes = extraClass.split(" ");
			for (const c of classes) {
				this.mapObject._icon.classList.add(c);
			}
		}
	},
	mounted() {
		// console.log(this.icon);
		// console.log(this.mapObject);
		// console.log(this.mapObject._icon);
		this.mapObject._icon.classList.add(...this.extraClass.split(" "));
	},
	watch: {
		options(val) {
			if ("opacity" in val) {
				this.mapObject._icon.style.opacity = val.opacity;
			}
		},
		extraClass(val, old) {
			/*
			console.log(
				this,
				"Marker Extra Class Change:",
				val,
				old,
				this.mapObject,
				this.mapObject._icon,
				this.mapObject._icon.classList
			);
			*/
			try {
				if (!_.isEmpty(old)) {
					const classes = old.split(" ");
					for (const c of classes) {
						this.mapObject._icon.classList.remove(c);
					}
				}
				if (!_.isEmpty(val)) {
					this.setExtraClass(val);
				}
			} catch (err) {
				console.warn(err);
			}
			return val;
		}
	}
};
